import css from './styles.module.scss'

const Spacer = ({
    sizeMobile,
    sizeDesktop
}) => (
    <>
        <div
            className={css.mobile}
            style={{ height: sizeMobile }}
        />
        <div
            className={css.desktop}
            style={{ height: sizeDesktop }}
        />
    </>
)

export default Spacer;